import { __assign } from "tslib";
import { IconButton } from '../../IconButton';
import { Menu } from '../../Menu';
import { MenuItem } from '../../MenuItem';
export var components = {
    Menu: Menu,
    MenuItem: MenuItem,
    Button: IconButton,
};
export var defaultComponents = function (overrideComponents) { return (__assign(__assign({}, components), overrideComponents)); };
//# sourceMappingURL=Breadcrumbs.components.js.map